import { computed, watch } from "vue";
import { useToast } from "vue-toast-notification";
import { ERROR_TIMEOUT, LIBRARY_IDS, SHARED_OVERRIDE_REASON_IDS, SPECIAL_EVENT_REASON_ID } from "@/constants.ts";
import { useGetOverrideReasons } from "@/providers/overrideReasons/useGetOverrideReasons";

export const getOverrideReasons = () => {
  const { data, isError } = useGetOverrideReasons({
    limit: 20,
    skip: 0,
    getArchived: false,
    q: "",
    useQueryOptions: {},
  });
  const toast = useToast();

  const override_reasons = computed(() => data.value?.items ?? []);

  const isSharedReason = (reason) => {
    return SHARED_OVERRIDE_REASON_IDS.includes(reason?.id);
  };

  const isSpecialEventReason = (reason) => {
    return reason?.id === SPECIAL_EVENT_REASON_ID;
  };

  const reasonRelatedToEvent = (reason) => {
    return reason?.skus?.some((sku) => sku?.library_id === LIBRARY_IDS.events);
  };
  const reasonRelatedToMiscProducts = (reason) => {
    return reason?.skus?.some((sku) => sku?.library_id === LIBRARY_IDS.miscProducts);
  };

  const eventOverrideReasonsKeep = computed(() => {
    return override_reasons.value.filter((reason) => {
      return isSpecialEventReason(reason) || isSharedReason(reason) || reasonRelatedToEvent(reason);
    });
  });

  const eventOverrideReasons = computed(() => {
    return override_reasons.value.filter((reason) => {
      return reasonRelatedToEvent(reason);
    });
  });
  const miscProductsOverrideReasons = computed(() => {
    return override_reasons.value.filter((reason) => {
      return reasonRelatedToMiscProducts(reason);
    });
  });

  const reasonsRelatedToHousing = (reason) => {
    return reason?.skus?.some((sku) => sku?.library_id === LIBRARY_IDS.housing);
  };

  const housingOverrideReasonsKeep = computed(() => {
    return override_reasons.value.filter((reason) => {
      return isSharedReason(reason) || reasonsRelatedToHousing(reason);
    });
  });

  const miscProductsOverrideReasonsKeep = computed(() => {
    return override_reasons.value.filter((reason) => {
      return isSharedReason(reason) || reasonRelatedToMiscProducts(reason);
    });
  });

  const housingOverrideReasons = computed(() => {
    return override_reasons.value.filter((reason) => {
      return reasonsRelatedToHousing(reason);
    });
  });

  watch(isError, (errorOccurred) => {
    if (errorOccurred) {
      toast.open({
        message: "Issues when retrieving override reasons.",
        type: "error",
        position: "bottom",
        duration: ERROR_TIMEOUT,
      });
    }
  });

  return {
    keepPriceReasons: {
      events: eventOverrideReasonsKeep,
      housings: housingOverrideReasonsKeep,
      misc: miscProductsOverrideReasonsKeep,
    },
    customPriceReasons: {
      events: eventOverrideReasons,
      housings: housingOverrideReasons,
      misc: miscProductsOverrideReasons,
    },
  };
};
